import { render, staticRenderFns } from "./RatingsColumns.vue?vue&type=template&id=7f89cdc3&"
import script from "./RatingsColumns.vue?vue&type=script&lang=js&"
export * from "./RatingsColumns.vue?vue&type=script&lang=js&"
import style0 from "./RatingsColumns.vue?vue&type=style&index=0&id=7f89cdc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports